var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRulePoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "#D90000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05719 7.05719C3.57789 7.57789 4.42211 7.57789 4.94281 7.05719L7.05719 4.94281C7.57789 4.42211 7.57789 3.57789 7.05719 3.05719L4.94281 0.942808C4.42211 0.422109 3.57789 0.42211 3.05719 0.942809L0.942808 3.05719C0.422109 3.57789 0.42211 4.42211 0.942809 4.94281L3.05719 7.05719Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulePoint);
export default __webpack_public_path__ + "static/media/rule-point.98d78ad7d12e3ad3b63dfb329ea793bd.svg";
export { ForwardRef as ReactComponent };